
import Axios from "axios";
import { apiInstance } from "./apiInstance";
import localStore from "./localstore.util";

import { parseJwt } from "../utils/parseToken";
import { LOGIN_TOKEN } from "./AuthApi";
import { appNavigate } from "./navigation";

export function setToken(token) {
  Object.assign(apiInstance.defaults.headers, {
    Authorization: `Bearer ${token}`,
  });
}
export async function handleRequest(request) {
  // SpotOn has no refresh-token endpoint; attach the stored JWT if present.
  let login_token = await localStore.get_data(LOGIN_TOKEN);
  if (login_token) {
    let decodedJwt = parseJwt(login_token);
    if (decodedJwt?.exp && Math.floor(new Date().getTime() / 1000) >= decodedJwt.exp) {
      await localStore.remove_all();
      if (typeof window !== "undefined" && !window.location.pathname.includes("/login")) {
        appNavigate("/login");
      }
      return request;
    }
    request.headers.Authorization = `Bearer ${login_token}`;
  }
  return request;
}
export function handleResponse(value) {
  return value;
}
export async function handleApiError(error) {
  if (Axios.isCancel(error)) {
    throw error;
  }
  if (!error.response) {
    throw error;
  }
  if (error.response.status === 401) {
    await localStore.remove_all();
    if (typeof window !== "undefined" && !window.location.pathname.includes("/login")) {
      appNavigate("/login");
    }
    return error;
  } else if (error.response.status === 403) {
    throw error;
  } else if (error.response.status === 500) {
    throw error;
  } else {
    // showToast(error.toString());
  }
  throw error;
}
